import Button from './Button';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../hooks/useTheme';

export const TextPageType = {
  DEFAULT: 1,
  ONE_SIDE: 2,
  SMALL_PARAGRAPH: 3,
};

const TypeClass = {
  [TextPageType.DEFAULT]: 'default',
  [TextPageType.ONE_SIDE]: 'one-side',
  [TextPageType.SMALL_PARAGRAPH]: 'small-paragraph',
};

const TextPage = ({
  type = TextPageType.DEFAULT,
  titleActive,
  titleInactive,
  titleInactiveItalic,
  paragraphText,
  buttonText,
  buttonLink,
  className,
}) => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  return (
    <div
      className={`text-page page-wrapper flex flex-column overflow-hidden ${
        isDarkMode ? '' : 'dark-menu-section'
      }  ${className ?? ''}`}
    >
      <div className={`text-page-titles flex full-width ${TypeClass[type]}`}>
        <p className='uppercase full-width sec-nd-hp-p font-primary'>
          <span>{titleActive} </span>
          <span className='no-wrap-word non-active'>{titleInactive}</span>{' '}
          <span className='font-secondary non-active'>
            {titleInactiveItalic}
          </span>
        </p>
      </div>
      <div
        className={`align-self-end flex row-gap-40 flex-column text-page-content ${TypeClass[type]}`}
      >
        <p className='paragraph-font-grotesk align-self-end'>{paragraphText}</p>
        {buttonText && buttonLink && (
          <Button
            variant={isDarkMode ? '' : 'dark'}
            showIcon={true}
            onClick={() => navigate(buttonLink)}
          >
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default TextPage;
